import styled from '@emotion/styled'

import { palette, spacing, Text } from 'main/ui'

export const Container = styled.div`
  background-color: ${palette.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
`

export const ContentContainer = styled.div`
  flex-grow: 1;
  margin-bottom: ${spacing.majorScale(4) + spacing.majorScale(2) + 24}px;
  overflow-y: auto;
  padding: 0 ${spacing.majorScale(1)}px;
`

export const FieldsContainer = styled.div`
  padding: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(5)}px;
  }
`

export const HeaderContainer = styled.div`
  align-items: center;
  background-color: ${palette.white};
  border-bottom: 1px solid ${palette.chrome};
  display: flex;
  flex-direction: row;
  min-height: 55px;
  justify-content: space-between;
  padding: 0 ${spacing.majorScale(2)}px 0 ${spacing.minorScale(5)}px;
`

export const CrossIconContainer = styled.div`
  color: ${palette.mediumGray};
  cursor: pointer;
  min-width: 14px;
  width: 14px;
`

export const ClearAllText = styled(Text)`
  color: ${palette.skyBlue2};
  cursor: pointer;
`

export const ShowResultsContainer = styled.div`
  align-items: center;
  background-color: ${palette.white};
  border-bottom: 1px solid ${palette.chrome};
  border-top: 1px solid ${palette.chrome};
  bottom: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding-bottom: ${spacing.majorScale(4)}px;
  padding-top: ${spacing.majorScale(2)}px;
  position: fixed;
  width: 100%;
`

export const ShowResultsText = styled(Text)`
  color: ${palette.skyBlue2};
`
